import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ContactPaymentDetailsPage.ContactList.Item', {
    hasDetails: 'HAS DETAILS',
});
